if (!customElements.get('brgy-hero')) {
  customElements.define('brgy-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      const track = this.querySelector('.brgy-hero__slides');
      const slides = [...this.querySelectorAll('.brgy-hero__slide')];
      const controls = this.querySelector('.brgy-hero__controls');
      if (!track || !controls || slides.length < 2) return;
      controls.hidden = false;
      const dots = [...this.querySelectorAll('[data-slide]')];
      const toggle = this.querySelector('[data-autoplay-toggle]');
      const status = this.querySelector('.brgy-hero__status');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = this.dataset.autoplay !== 'true' || motion.matches || Boolean(window.Shopify?.designMode);
      let visible = true;
      let index = 0;
      const syncPlayback = () => {
        clearInterval(this.timer);
        this.timer = null;
        const playing = !paused && visible && !document.hidden;
        status.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (toggle) {
          toggle.setAttribute('aria-label', paused ? 'Play automatic slideshow' : 'Pause automatic slideshow');
          toggle.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        }
        if (playing) this.timer = setInterval(() => go(index + 1), Number(this.dataset.interval) || 3000);
      };
      const update = () => {
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        this.querySelector('.brgy-hero__location').textContent = slides[index].dataset.label;
        this.querySelector('.brgy-hero__status').textContent = `Image ${index + 1} of ${slides.length}: ${slides[index].dataset.label}`;
        const upcomingImage = slides[(index + 1) % slides.length].querySelector('img');
        if (upcomingImage) upcomingImage.loading = 'eager';
      };
      const go = (target) => {
        index = (target + slides.length) % slides.length;
        const image = slides[index].querySelector('img');
        if (image) image.loading = 'eager';
        update();
      };
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-autoplay-toggle')) {
          paused = !paused;
          syncPlayback();
          return;
        }
        paused = true;
        syncPlayback();
        go(button.hasAttribute('data-slide') ? Number(button.dataset.slide) : index + Number(button.dataset.direction));
      }, { signal });
      controls.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        paused = true;
        syncPlayback();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.classList.add('is-ready');
      update();
      this.addEventListener('focusin', (event) => {
        if (event.target.closest('[data-autoplay-toggle]')) return;
        paused = true;
        syncPlayback();
      }, { signal });
      let touchStart = null;
      track.addEventListener('pointerdown', (event) => {
        touchStart = { x: event.clientX, y: event.clientY };
        track.setPointerCapture(event.pointerId);
      }, { signal });
      track.addEventListener('pointerup', (event) => {
        if (!touchStart) return;
        const dx = event.clientX - touchStart.x;
        const dy = event.clientY - touchStart.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          go(index + (dx < 0 ? 1 : -1));
          syncPlayback();
        }
        touchStart = null;
      }, { signal });
      track.addEventListener('pointercancel', () => { touchStart = null; }, { signal });
      document.addEventListener('visibilitychange', syncPlayback, { signal });
      motion.addEventListener('change', () => { if (motion.matches) paused = true; syncPlayback(); }, { signal });
      this.visibility = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; syncPlayback(); });
      this.visibility.observe(this);
      syncPlayback();
      document.addEventListener('shopify:block:select', (event) => {
        const selected = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (selected >= 0) { paused = true; syncPlayback(); go(selected); }
      }, { signal });
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.visibility?.disconnect(); }
  });
}
